angular.module('iconoglobe')
    .config(['$sceDelegateProvider',
        function ($sceDelegateProvider) {
            //$sceDelegateProvider
            $sceDelegateProvider.resourceUrlWhitelist([
                'self',
                'https://iconoglobe.com/**',
                '**',
            ]);
        }])
    .config(['$compileProvider', "tmhDynamicLocaleProvider", "AnalyticsProvider", function ($compileProvider, tmhDynamicLocaleProvider, AnalyticsProvider) {

        // $compileProvider
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|skype|chrome-extension|file|tel|whatsapp|weixin|fb-messenger):/);
        $compileProvider.debugInfoEnabled(false);

    
		//console.log("tmhDynamicLocaleProvider.localeLocationPattern",tmhDynamicLocaleProvider.localeLocationPattern.locale);
        tmhDynamicLocaleProvider.localeLocationPattern('app/components/angular-i18n/angular-locale_{{locale}}.js') ;

        // google analytics
        AnalyticsProvider.setAccount('UA-104111034-1');  //UU-XXXXXXX-X should be your tracking code
    }])
    .config(function ($authProvider, $provide) {
        // FIXED: Correctly injecting $delegate (which represents $rootScope in this decorator)
        $provide.decorator('$rootScope', ['$delegate', function ($delegate) {
            $delegate['$onRootScope'] = function (eventName, callback) {
                var unbind = $delegate.$on(eventName, callback);
                this.$on('$destroy', unbind);
            };
            return $delegate;
        }]);


        var facebookAppId = '1260352757425721';
        var googleAppId = '309894020134-49bfbquor3b3isd25052p8ttkadtd2ni.apps.googleusercontent.com';
        var vkAppId = '6118142';
        var weiboAppId = '1746413473';

        var siteBaseUrl = window.location.host;
        var redirectUri = "https://" + window.location.host;
        if (siteBaseUrl == "iconoglobe.cn" || siteBaseUrl == "www.iconoglobe.cn") {
            facebookAppId = '1923085841248777';
        } else {
            // siteBaseUrl = 'iconoglobe.com';
        }

        if (siteBaseUrl.indexOf('iconoglobe') < 0) {
            redirectUri = "http://" + window.location.host;
            facebookAppId = '432456620423522';
            googleAppId = '87151937150-pch57un6tqea337ipqbmk9j544crn74q.apps.googleusercontent.com';
            var vkAppId = '6241381';
            var googleSecret = 'eT3Qm_XW8DIpJIGLEimrUb-t'
        }


        $authProvider.facebook({
            clientId: facebookAppId,
            name: 'facebook',
            url: '/auth/facebook',
            authorizationEndpoint: 'https://www.facebook.com/v2.5/dialog/oauth',
            redirectUri: window.location.origin + '/login',
            requiredUrlParams: ['display', 'scope'],
            scope: ['email'],
            scopeDelimiter: ',',
            display: 'popup',
            oauthType: '2.0',
            popupOptions: {width: 580, height: 400},
            responseType: 'token'
        });

        $authProvider.google({
            clientId: googleAppId,
            url: redirectUri + '/login',
            redirectUri: redirectUri + "/login",
            authorizationEndpoint: 'https://accounts.google.com/o/oauth2/auth',
            requiredUrlParams: ['scope'],
            optionalUrlParams: ['display'],
            scope: ['profile', 'email'],
            scopePrefix: 'openid',
            scopeDelimiter: ' ',
            display: 'popup',
            oauthType: '2.0',
            responseType: "token",
            popupOptions: {width: 452, height: 633}
        });

        $authProvider.twitch({
            client_id: weiboAppId,
            clientId: weiboAppId,
            url: '/login',
            authorizationEndpoint: 'https://api.weibo.com/oauth2/authorize',
            redirectUri: redirectUri + '/login',
            requiredUrlParams: ['scope'],
            optionalUrlParams: ['display'],
            scope: ['profile', 'email'],
            scopePrefix: 'openid',
            scopeDelimiter: ' ',
            display: 'popup',
            oauthType: '2.0',
            responseType: "token",
            popupOptions: {width: 452, height: 633}
        });

        $authProvider.spotify({
            client_id: vkAppId,
            clientId: vkAppId,
            url: '/login',
            authorizationEndpoint: 'https://oauth.vk.com/authorize',
            redirectUri: redirectUri + '/login',
            requiredUrlParams: ['scope'],
            optionalUrlParams: ['display'],
            scope: ['profile', 'email'],
            scopePrefix: 'openid',
            scopeDelimiter: ' ',
            display: 'popup',
            oauthType: '2.0',
            responseType: "token",
            popupOptions: {width: 452, height: 633}
        });
        // No additional setup required for Twitter


    })
    .config(function ($translateProvider, DEBUG_MODE, LOCALES, LOCALES_BROWSER) {

        var lang = window.navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage);

        if (DEBUG_MODE) {
            $translateProvider.useMissingTranslationHandlerLog();// warns about missing translates
        }

        $translateProvider.useSanitizeValueStrategy(null);
        $translateProvider.useStaticFilesLoader({
            prefix: 'app/resources/locale-',
            suffix: '.json'
        });

        $translateProvider.fallbackLanguage('en_US');

        var siteBaseUrl = window.location.host;

        var index = lang.indexOf('-');
        if (index < 0)
            lang = lang + '_' + lang.toUpperCase();
        else
            lang = lang.replace("-", "_");

        switch (siteBaseUrl) {
            case "iconoglobe.com":
                $translateProvider.preferredLanguage("en_US");
                break;
            case "iconoglobe.cn":
                $translateProvider.preferredLanguage("zh_ZH");
                break;
            case "hk.iconoglobe.cn":
                $translateProvider.preferredLanguage("zh_ZH");
                break;
            case "tw.iconoglobe.cn":
                $translateProvider.preferredLanguage("zh_ZH");
                break;
            case "www.iconoglobe.cn":
                $translateProvider.preferredLanguage("zh_ZH");
                break;
            case "af.iconoglobe.com":
                $translateProvider.preferredLanguage("af_AF");
                break;
            case "bg.iconoglobe.com":
                $translateProvider.preferredLanguage("bg_BG");
                break;
            case "zh.iconoglobe.com":
                $translateProvider.preferredLanguage("zh_ZH");
                break;
            case "cs.iconoglobe.com":
                $translateProvider.preferredLanguage("cs_CS");
                break;
            case "da.iconoglobe.com":
                $translateProvider.preferredLanguage("da_DA");
                break;
            case "de.iconoglobe.com":
                $translateProvider.preferredLanguage("de_DE");
                break;
            case "el.iconoglobe.com":
                $translateProvider.preferredLanguage("el_EL");
                break;
            case "us.iconoglobe.com":
                $translateProvider.preferredLanguage("en_US");
                break;
            case "es.iconoglobe.com":
                $translateProvider.preferredLanguage("es_ES");
                break;
            case "fa.iconoglobe.com":
                $translateProvider.preferredLanguage("fa_FA");
                break;
            case "fi.iconoglobe.com":
                $translateProvider.preferredLanguage("fi_FI");
                break;
            case "fr.iconoglobe.com":
                $translateProvider.preferredLanguage("fr_FR");
                break;
            case "he.iconoglobe.com":
                $translateProvider.preferredLanguage("he_HE");
                break;
            case "hr.iconoglobe.com":
                $translateProvider.preferredLanguage("hr_HR");
                break;
            case "hu.iconoglobe.com":
                $translateProvider.preferredLanguage("hu_HU");
                break;
            case "id.iconoglobe.com":
                $translateProvider.preferredLanguage("id_ID");
                break;
            case "it.iconoglobe.com":
                $translateProvider.preferredLanguage("it_IT");
                break;
            case "ja.iconoglobe.com":
                $translateProvider.preferredLanguage("ja_JA");
                break;
            case "ko.iconoglobe.com":
                $translateProvider.preferredLanguage("ko_KO");
                break;
            case "lt.iconoglobe.com":
                $translateProvider.preferredLanguage("lt_LT");
                break;
            case "nl.iconoglobe.com":
                $translateProvider.preferredLanguage("nl_NL");
                break;
            case "no.iconoglobe.com":
                $translateProvider.preferredLanguage("no_NO");
                break;
            case "pl.iconoglobe.com":
                $translateProvider.preferredLanguage("pl_PL");
                break;
            case "pt.iconoglobe.com":
                $translateProvider.preferredLanguage("pt_PT");
                break;
            case "ro.iconoglobe.com":
                $translateProvider.preferredLanguage("ro_RO");
                break;
            case "ru.iconoglobe.com":
                $translateProvider.preferredLanguage("ru_RU");
                break;
            case "sk.iconoglobe.com":
                $translateProvider.preferredLanguage("sk_SK");
                break;
            case "sl.iconoglobe.com":
                $translateProvider.preferredLanguage("sl_SL");
                break;
            case "sr.iconoglobe.com":
                $translateProvider.preferredLanguage("sr_SR");
                break;
            case "sv.iconoglobe.com":
                $translateProvider.preferredLanguage("sv_SV");
                break;
            case "tr.iconoglobe.com":
                $translateProvider.preferredLanguage("tr_TR");
                break;
            case "uk.iconoglobe.com":
                $translateProvider.preferredLanguage("uk_UK");
                break;
            case "vi.conoworld.com":
                $translateProvider.preferredLanguage("vi_VI");
                break;
            case "ar.iconoglobe.com":
                $translateProvider.preferredLanguage("ar_AR");
                break;
            case "km.iconoglobe.com":
                $translateProvider.preferredLanguage("km_KM");
                break;
            case "bs.iconoglobe.com":
                $translateProvider.preferredLanguage("bs_BS");
                break;
            case "hi.iconoglobe.com":
                $translateProvider.preferredLanguage("hi_HI");
                break;
            default:
                $translateProvider.preferredLanguage(lang);
        }

        var path = window.location.pathname

       // traceLog("config", "path name is ", path)
       // traceLog("config", "site base url is ", siteBaseUrl)

        function setCookie(key, value) {
            var d = new Date();
            var exdays = 30;
            d.setTime(d.getTime() + (30*24*60*60*1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = "lang_pref=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            document.cookie = key + "=" + value + ";" + expires + ";domain=iconoglobe.com; path=" + path;
        }

        //traceLog("config", "Set language cookie")
        angular.forEach(LOCALES.locales, function (v, k) {
            var languageUrl = v[1].replace('https://', '').replace('http://', '');
            if (siteBaseUrl === languageUrl) {
               // traceLog("config", "Selected language key [" + k + "], for [" + v[1] + "]")
               // traceLog("config", "setting language cookie [lang_pref] as ", k)
                setCookie("lang_pref", k);
            }
        });
    });